import React from 'react';

export const DEFAULT_ICON_SIZE = 24;

interface Props {
  className?: string;
}

const HotelsIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={DEFAULT_ICON_SIZE}
      height={DEFAULT_ICON_SIZE}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M15 8l4.395.015a.6.6 0 0 1 .6.6l-.014 8.404h1.022V19H15V8zm-1.03-3.4V19H3v-1.997h1V4.6c0-.331.307-.6.638-.6h8.732a.6.6 0 0 1 .6.6zM6 10v2h2v-2H6zm0 4v2h2v-2H6zm4-4v2h2v-2h-2zm0-4v2h2V6h-2zm5 4v2h3v-2h-3zm0 4v2h3v-2h-3zm-5 0v2h2v-2h-2zM6 6v2h2V6H6z"
      />
    </svg>
  );
};

export default HotelsIcon;
